// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__jid0L","image":"Banner_image__TduG4","content":"Banner_content__EKH5J","description":"Banner_description__GTHVM","append":"Banner_append__w5BqG"};